import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { LoadingService } from '../../../../../services/loading.service';
import { UserService } from '../../../../../services/user.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UserEditComponent } from '../user-edit/user-edit.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [ToastModule, DividerModule, PanelModule, DropdownModule, ButtonModule, TableModule, ConfirmPopupModule],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.css',
  providers: [MessageService, DialogService, ConfirmationService]
})
export class UserListComponent {

  loadingService = inject(LoadingService);
  userService = inject(UserService);
  messageService = inject(MessageService);
  router = inject(Router)
  dialogService = inject(DialogService);
  confirmationService = inject(ConfirmationService);

  loading = false;
  ref: DynamicDialogRef | undefined;

  users: any[] = [];

  usersCount = 1;

  acceptLabel: string = "Jawohl!";
  rejectLabel: string = "Nein, doch nicht!";

  ngOnInit(): void {

    this.loadUser()
  }


  loadUser() {
    this.loadingService.addCounter();

    this.userService.getAll().subscribe({
      next: (data) => {
        if (data.success == 1) {
          this.users = data.data.users;
        }
        else {
          this.messageService.add({ key: 'tc', severity: 'error', summary: data.message });
        }

        this.loading = false;
        this.loadingService.removeCounter();
      },
      error: (error) => {
        if (error.status == 401) {
          console.log("Fehler! Auf zum Login!")
          this.loadingService.removeCounter();
          this.router.navigateByUrl("/logout");
        }
      }
    }
    );
  }

  newUser() {
    let emptyUser = {
      "usersid": "",
      "firstname": "",
      "lastname": "",
      "email": "",
      "is_administrator": "N",
      "default_theme": "",
      "niederlassung_id": ""
    }
    this.editUser(emptyUser);
  }

  editUser(user: any) {
    console.log("Edit User: ", user);
    this.ref = this.dialogService.open(UserEditComponent, {
      data: {
        user: user
      },
      header: "Benutzer bearbeiten",
      width: '60%',
      contentStyle: { "overflow": "auto" },
      baseZIndex: 10000
    })

    this.ref.onClose.subscribe((data) => {
      console.log(data);
      if (data == "created") {
        this.messageService.add({ key: 'tc', severity: 'success', summary: 'Bestätigung', detail: 'Benutzer wurde angelegt!' });
        this.loadUser();
      }
      if (data == "updated") {
        this.messageService.add({ key: 'tc', severity: 'success', summary: 'Bestätigung', detail: 'Benutzer wurde bearbeitet!' });
        this.loadUser();
      }
      if (data == "pwdone") {
        this.messageService.add({ key: 'tc', severity: 'success', summary: 'Bestätigung', detail: 'Passwort wurde aktualisiert!' });
        this.loadUser();
      }

    });
  }

  deleteUser(event: Event, userid: string, index: number) {
    console.log("Delete User: ", userid);
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Soll der Benutzer wirklich gelöscht werden?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        console.log(userid);

        this.loadingService.addCounter();
        this.userService.deleteUser(userid).subscribe({
          next: (res) => {
            if (res.success == 1) {

              console.log(res.data);

              this.messageService.add({ key: 'tc', severity: 'info', summary: 'Benutzer gelöscht', detail: res.message });
              this.loadUser();

            }
          }
        });
      },
      reject: () => {
        //reject action
      }
    });
  }

  getAdminState(state: string) {
    if (state == "Y") {
      return "Ja";
    } else { } return "Nein"
  };
}
